/* eslint-disable react/prop-types */
import React from 'react';
import MdIcon from '~/shared/components/mdIcon';

import { ErrorInfo, Error } from './styles';

const AlertMessage = ({ alert = true, icon, message, background = true }) => {
  return (
    <ErrorInfo alert={alert} background={background}>
      <MdIcon size={0.8} icon={icon} color="#fff" />
      <Error>{message}</Error>
    </ErrorInfo>
  );
};

export default AlertMessage;
